import messageResource from "../../../messageResource";
import LeaveTypeStore from "../../../store/LeaveTypeStore";
import UserTime from "../../../user_time";
import PDFImageCache from "../../../pdf/PDFImageCache";
import ViewTTStore from "../ViewTTStore";
import {selectStatusByTask} from "../../../workflowStatus/selectors";
import {unsafe_selectWithState} from "../../../redux/utils";
import {getPdfColorByColorIdAndStatusType, getPdfIconNameByType} from "./utils";

const DataTableCreateDefinitionHelper = function(ddBuilder, tableData, config)
{
    this.ddBuilder = ddBuilder;
    this.tableData = tableData;
    this.config = config;

    this.labels = {
        nonWorkingLabel: messageResource.getMessage("view_tt.details_table.day_row.non_working"),
        approvedLabel: messageResource.getMessage("view_tt.details_table.day_row.approved"),
        autoApprovedLabel: messageResource.getMessage("view_tt.details_table.day_row.auto_approved"),
        notReadyLabel: messageResource.getMessage("view_tt.details_table.day_row.not_ready"),
        readyLabel: messageResource.getMessage("view_tt.details_table.day_row.ready"),
        rejectedLabel: messageResource.getMessage("view_tt.details_table.day_row.rejected"),
        workingTimeLabel: messageResource.getMessage("view_tt.details_table.day_row.working_time"),
        overtimeLabel: messageResource.getMessage("overtime.overtime"),
        leaveTimeLabel: messageResource.getMessage("view_tt.details_table.day_row.leave_time"),
        autoOvertime: messageResource.getMessage("view_tt.details_table.overtime_row.auto")
    };
};

DataTableCreateDefinitionHelper.prototype = {

    createTable: function()
    {
        var showTasks = this.config.showTasks;
        var rows = [];
        var rowTypes = ViewTTPageUtils.RowType;
        for (var i = 0; i < this.tableData.length; i++)
        {
            var rowData = this.tableData[i];

            var rowDefinition;
            var data;
            var isWeekend;
            var day;
            var task;
            var overtime;
            var taskObject;
            var otherTTInfo;
            switch (rowData.type)
            {
                case rowTypes.DAY:
                {
                    day = rowData["dayModel"];

                    var isLeaveTimePresent = !_.isNull(day["leave"]);
                    var isOvertimePresent = !_.isNull(day["overtime"]);

                    var workingTime = day["totalWorkingTime"];
                    var leaveTime = isLeaveTimePresent ? day["leave"]["leaveTime"] : 0;
                    overtime = isOvertimePresent ?
                               (_.isNull(day["overtime"]["reported"]) ? day["overtime"]["auto"] : day["overtime"]["reported"]) : 0;

                    var isEmptyLeaveTime = !isLeaveTimePresent || leaveTime == 0;
                    var isEmptyOvertime = !isOvertimePresent || overtime == 0;
                    var isEmptyWorkingTime = workingTime == 0;

                    var totalTime = leaveTime + workingTime;
                    isWeekend = this.isWeekend(day);

                    var descriptionSection = [];
                    if (!showTasks)
                    {
                        var leaveTypeName = isEmptyLeaveTime ? this.labels.leaveTimeLabel : LeaveTypeStore.getLeaveType(day["leave"]["leaveTypeId"])["name"];
                        var descriptionData = {
                            workingTime: this.labels.workingTimeLabel + ": " + (!isEmptyWorkingTime ? UserTime.formatTimeWithDigitSeparator(workingTime) : "--"),
                            leaveTime: leaveTypeName + ": " + (!isEmptyLeaveTime ? UserTime.formatTimeWithDigitSeparator(leaveTime) : "--"),
                            overtime: this.labels.overtimeLabel + ": " + (!isEmptyOvertime ? UserTime.formatTimeWithDigitSeparator(overtime) : "--")
                        };
                        var descriptionParams = {
                            isEmptyWorkingTime: isEmptyWorkingTime,
                            isEmptyOvertime: isEmptyOvertime,
                            isEmptyLeaveTime: isEmptyLeaveTime,
                            isLeaveTimePresent: isLeaveTimePresent,
                            isOvertimePresent: isOvertimePresent
                        };
                        descriptionSection = this.ddBuilder.crateDayRowDescription(descriptionData, descriptionParams);
                    }

                    var approvalStatusLabel = "";
                    var statusClass = "";
                    switch (day["approvalStatus"])
                    {
                        case EffectiveWeekApprovalStatus.AUTO_APPROVED:
                            approvalStatusLabel = this.labels.autoApprovedLabel;
                            statusClass = "approved";
                            break;
                        case EffectiveWeekApprovalStatus.APPROVED:
                            approvalStatusLabel = this.labels.approvedLabel;
                            statusClass = "approved";
                            break;
                        case EffectiveWeekApprovalStatus.NOT_READY:
                            approvalStatusLabel = this.labels.notReadyLabel;
                            statusClass = "notReady";
                            break;
                        case EffectiveWeekApprovalStatus.READY:
                            approvalStatusLabel = this.labels.readyLabel;
                            statusClass = "ready";
                            break;
                        case EffectiveWeekApprovalStatus.REJECTED:
                            approvalStatusLabel = this.labels.rejectedLabel;
                            statusClass = "rejected";
                            break;
                    }

                    data = {
                        category: this.config["dateFormat"].formatDate(day.date),
                        total: UserTime.formatTimeWithDigitSeparator(totalTime),
                        statusLabel: approvalStatusLabel,
                        nonWorkingLabel: isWeekend ? this.labels.nonWorkingLabel : "",
                        lockImage: PDFImageCache.getImage("lockedDay")["image"]
                    };

                    var params = {
                        isWeekend: isWeekend,
                        statusClass: statusClass,
                        isEmptyTotal: totalTime == 0,
                        locked: day["locked"]
                    };

                    rowDefinition = this.ddBuilder.createDayRow(data, params, descriptionSection);
                    break;
                }
                case rowTypes.TASK_BY_DAY:
                {
                    if (!showTasks) continue;

                    day = rowData["dayModel"];
                    isWeekend = this.isWeekend(day);
                    task = rowData["taskModel"];
                    taskObject = ViewTTStore.getTask(task["taskId"]);
                    const workflowStatus = unsafe_selectWithState(state => selectStatusByTask(state, taskObject));
                    data = {
                        category: taskObject.name,
                        customerName: ViewTTStore.getCustomer(task["customerId"])["name"],
                        projectName: ViewTTStore.getProject(task["projectId"])["name"],
                        total: UserTime.formatTimeWithDigitSeparator(task["spent"]),
                        comment: _.isNull(task["comment"]) ? '' : task["comment"],
                        color: getPdfColorByColorIdAndStatusType(workflowStatus.colorId, workflowStatus.type),
                        image: PDFImageCache.getImage(getPdfIconNameByType(workflowStatus.type))["image"]
                    };

                    params = {
                        isWeekend: isWeekend,
                        isCompleted: taskObject["completed"]
                    };
                    rowDefinition = this.ddBuilder.createTaskByDayRow(data, params);
                    break;
                }
                case rowTypes.LEAVE:
                {
                    if (!showTasks) continue;

                    day = rowData["dayModel"];
                    isWeekend = this.isWeekend(day);
                    var leaveType = LeaveTypeStore.getLeaveType(day["leave"]["leaveTypeId"]);
                    data = {
                        image: PDFImageCache.getImage("leaveTypeIcon_" + leaveType["iconId"])["image"],
                        category: leaveType["name"],
                        total: UserTime.formatTimeWithDigitSeparator(day["leave"]["leaveTime"])
                    };
                    params = {
                        isWeekend: isWeekend
                    };
                    rowDefinition = this.ddBuilder.createLeaveRow(data, params);
                    break;
                }
                case rowTypes.OVERTIME:
                {
                    if (!showTasks) continue;

                    day = rowData["dayModel"];
                    isWeekend = this.isWeekend(day);
                    overtime = day["overtime"];
                    var total = _.isNumber(overtime["reported"]) ? overtime["reported"] : overtime["auto"];
                    var autoTotal = overtime["auto"];
                    var isNeedToShowAuto = total != autoTotal;
                    data = {
                        category: this.labels.overtimeLabel,
                        total: UserTime.formatTimeWithDigitSeparator(total),
                        autoOvertimeMsg: isNeedToShowAuto ?
                                         (this.labels.autoOvertime + " " + this.labels.overtimeLabel + " " + UserTime.formatTimeWithDigitSeparator(autoTotal)) : ""
                    };

                    params = {
                        isWeekend: isWeekend,
                        showAuto: isNeedToShowAuto
                    };
                    rowDefinition = this.ddBuilder.createOvertimeRow(data, params);
                    break;
                }
                case rowTypes.OTHER_SPENT_BY_DAY:
                {
                    if (!showTasks) continue;

                    day = rowData["dayModel"];
                    isWeekend = this.isWeekend(day);
                    otherTTInfo = day["otherTTInfo"];
                    data = {
                        category: this._createOtherTimeTrackLabel(otherTTInfo),
                        total: UserTime.formatTimeWithDigitSeparator(otherTTInfo["spent"])
                    };

                    params = {
                        isWeekend: isWeekend
                    };
                    rowDefinition = this.ddBuilder.createOtherSpentByDayRow(data, params);
                    break;
                }

                case rowTypes.CUSTOMER:
                {
                    var customer = rowData["customerModel"];
                    data = {
                        category: ViewTTStore.getCustomer(customer["customerId"])["name"],
                        total: UserTime.formatTimeWithDigitSeparator(customer["totalSpent"])
                    };

                    rowDefinition = this.ddBuilder.createCustomerRow(data);
                    break;
                }
                case rowTypes.PROJECT:
                {
                    var project = rowData["projectModel"];
                    data = {
                        category: ViewTTStore.getProject(project["projectId"])["name"],
                        total: UserTime.formatTimeWithDigitSeparator(project["totalSpent"])
                    };

                    rowDefinition = this.ddBuilder.createProjectRow(data);
                    break;
                }
                case rowTypes.TASK_BY_CP:
                {
                    if (!showTasks) continue;

                    task = rowData["taskModel"];
                    taskObject = ViewTTStore.getTask(task.taskId);
                    const workflowStatus = unsafe_selectWithState(state => selectStatusByTask(state, taskObject));
                    data = {
                        category: taskObject["name"],
                        total: UserTime.formatTimeWithDigitSeparator(task["totalSpent"]),
                        description: _.isNull(taskObject["description"]) ? '' : taskObject["description"],
                        color: getPdfColorByColorIdAndStatusType(workflowStatus.colorId, workflowStatus.type),
                        image: PDFImageCache.getImage(getPdfIconNameByType(workflowStatus.type))["image"]
                    };

                    params = {
                        isCompleted: taskObject["completed"]
                    };

                    rowDefinition = this.ddBuilder.createTaskByCpRow(data, params);
                    break;
                }
                case rowTypes.OTHER_SPENT_BY_CP:
                {
                    otherTTInfo = rowData["otherTTInfo"];
                    data = {
                        category: this._createOtherTimeTrackLabel(otherTTInfo),
                        total: UserTime.formatTimeWithDigitSeparator(otherTTInfo["spent"])
                    };

                    rowDefinition = this.ddBuilder.createOtherSpentByCpRow(data);
                    break;
                }
            }
            rows.push(rowDefinition);
        }

        var thereAreNoRows = rows.length == 0;
        if (thereAreNoRows)
        {
            var emptyDataMessage = this.config["viewByDays"] ?
                                   messageResource.getMessage("view_tt.details_table.no_day_rows") :
                                   messageResource.getMessage("view_tt.details_table.no_cp_rows");
            rows.push(this.ddBuilder.createEmptyDataRow(emptyDataMessage));
        }

        var titleByKey = this.config["viewByDays"] ? "view_tt.pdf.details_table.title_by_days" : "view_tt.pdf.details_table.title_by_cp";
        var titleMessage = messageResource.getMessage("view_tt.pdf.details_table.title", [messageResource.getMessage(titleByKey)]);

        this.ddBuilder.addDataTableWithHeader(titleMessage, rows);
    },

    isWeekend: function(dayModel)
    {
        return dayModel["workdayDuration"] == 0;
    },

    _createOtherTimeTrackLabel: function(otherTTInfo)
    {
        return messageResource.getMessage("view_tt.details_table.other_tt")
    }
};

export default DataTableCreateDefinitionHelper;


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/DataTableCreateDefinitionHelper.js